<template>
  <div>
    <Toolbar :handle-submit="onSendFormMultiple" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.products')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProductForm ref="createForm" :values="item" :defaultvalues="defaultvalues" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProductForm from '../../components/product/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Product';

const { mapFields } = createHelpers({
  getterType: 'product/getField',
  mutationType: 'product/updateField'
});

export default {
  name: 'ProductCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProductForm
  },
  data() {
    return {
      item: {
        location: 'Lynxter - Atelier',
        nbproduct: 1,
      },
      defaultvalues: {
      //  customerdefault: 'Lynxter',
        statutdefault: 'Assembly',
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),

  },
  methods: {
    ...mapActions('product', ['create', 'reset']),
    onSendFormMultiple() {
      const createForm = this.$refs.createForm;
      let nbproduct = createForm.$v.item.$model.nbproduct;
      console.log(nbproduct);
      if (nbproduct > 1) {
        console.log('multiple');
        createForm.$v.$touch();
        if (!createForm.$v.$invalid) {
          for (var i = 0; i < nbproduct; i++) {
            this.create(createForm.$v.item.$model);
          }

        }
      } else {
        console.log('normal');
        this.onSendForm();

      }
      /*
      const createForm = this.$refs.createForm;
      createForm.$v.$touch();
      if (!createForm.$v.$invalid) {
        this.create(createForm.$v.item.$model);
      }*/
    },
  },
};
</script>
